import { HeadGoverness } from 'vue-kindergarten';

class RouteGoverness extends HeadGoverness {
    constructor(from, to, next)
    {
        super();
        this.next = next;
    }

    guard(action)
    {
        this.next(super.isAllowed(action) ? undefined : '/error/401/Unauthorised+Access');
    }
}

export default RouteGoverness;
